import { track } from './core';

export function trackVulnMovedToFolder(appId, appName, folder, success = true) {
  track('vuln_moved_to_folder', { app_id: appId, app_name: appName, folder, success });
}

export function trackVulnFolderCreated(appId, appName, success = true) {
  track('vuln_folder_created', { app_id: appId, app_name: appName, success });
}

export function trackVulnMarkedFalsePositive(appId, appName, success = true) {
  track('vuln_marked_false_positive', { app_id: appId, app_name: appName, success });
}

export function trackVulnLinkCopied(appId, appName) {
  track('vuln_link_copied', { app_id: appId, app_name: appName });
}

export function trackVulnImageDownloaded(appId, appName) {
  track('vuln_image_downloaded', { app_id: appId, app_name: appName });
}

export function trackVulnImageDownloadFailed(appId, appName, error) {
  track('vuln_image_download_failed', { app_id: appId, app_name: appName, error });
}

export function trackVulnSectionExpanded(appId, appName, section) {
  track('vuln_section_expanded', { app_id: appId, app_name: appName, section });
}
